package de.oevbs.kunde.kundenportal2.model.services.deregistercar

import de.oevbs.businesspartner.bpcrmservice2.partner.model.Country
import de.oevbs.businesspartner.bpcrmservice2.partner.model.Salutation
import de.oevbs.kunde.kundenportal2.model.services.contract.CarContract
import de.oevbs.kunde.kundenportal2.validation.KupoValidationMessages
import de.oevbs.kunde.kundenportal2.validation.Regexes
import de.oevbs.kunde.kundenportal2.validation.validateUsingRegex
import de.oevbs.sfa.data.time.now
import dev.fritz2.core.Lenses
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.headless.validation.errorMessage
import dev.fritz2.validation.Validation
import dev.fritz2.validation.validation
import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.LocalDate
import kotlinx.datetime.minus
import kotlinx.serialization.Serializable

@Serializable
enum class VehicleAction(val text: String = "") {
    DEREGISTERED("Fahrzeug abgemeldet"),
    SCRAPPED("Fahrzeug verschrottet"),
    SOLD("Fahrzeug verkauft")
}

@Lenses
@Serializable
data class DeregisterCar(
    val unsubDate: LocalDate? = null,
    val vehicleAction: String = "",
    val selectedCarContract: CarContract? = null,
    val selectedCountry: Country = Country.Deutschland,
    val salutationBuyer: Salutation = Salutation.Frau,
    val companyBuyer: String = "",
    val firstnameBuyer: String = "",
    val lastnameBuyer: String = "",
    val streetNameBuyer: String = "",
    val streetNumberBuyer: String = "",
    val postalCodeBuyer: String = "",
    val locationBuyer: String = "",
) {
    companion object {
        val validation: Validation<DeregisterCar, Unit, ComponentValidationMessage> = validation { inspector ->
            val chosenVehicleAction = inspector.map(DeregisterCar.vehicleAction())

            if (chosenVehicleAction.data.isEmpty()) {
                add(chosenVehicleAction.errorMessage(KupoValidationMessages.EMPTY_SELECT))
            } else if (VehicleAction.SOLD.text == chosenVehicleAction.data) {
                val salutation = inspector.map(DeregisterCar.salutationBuyer())
                when (salutation.data) {
                    Salutation.Unbekannt -> add(salutation.errorMessage(KupoValidationMessages.EMPTY_SELECT))

                    Salutation.Firma -> {
                        val companyBuyer = inspector.map(DeregisterCar.companyBuyer())
                        if (companyBuyer.data.isEmpty()) {
                            add(companyBuyer.errorMessage("Bitte geben Sie den Firmennamen des Käufers an."))
                        }
                    }

                    else -> {
                        val firstnameBuyer = inspector.map(DeregisterCar.firstnameBuyer())
                        addAll(firstnameBuyer.validateUsingRegex(Regexes.name))

                        val lastnameBuyer = inspector.map(DeregisterCar.lastnameBuyer())
                        addAll(lastnameBuyer.validateUsingRegex(Regexes.name))
                    }
                }

                val streetSub = inspector.map(DeregisterCar.streetNameBuyer())
                addAll(streetSub.validateUsingRegex(Regexes.name))

                val streetNoSub = inspector.map(DeregisterCar.streetNumberBuyer())
                addAll(streetNoSub.validateUsingRegex(Regexes.streetNumber))

                val postalCodeSub = inspector.map(DeregisterCar.postalCodeBuyer())
                addAll(postalCodeSub.validateUsingRegex(Regexes.postalCode))

                val citySub = inspector.map(DeregisterCar.locationBuyer())
                addAll(citySub.validateUsingRegex(Regexes.name))

                val country = inspector.map(DeregisterCar.selectedCountry())
                if (country.data.key.isEmpty()) {
                    add(country.errorMessage(KupoValidationMessages.EMPTY_SELECT))
                }
            }

            val selectedCarContractStore = inspector.map(DeregisterCar.selectedCarContract())
            if (selectedCarContractStore.data == null) {
                add(selectedCarContractStore.errorMessage("Bitte wählen Sie einen Kfz-Vertrag aus."))
            }

            val selectDate = inspector.map(DeregisterCar.unsubDate())
            if (selectDate.data == null) {
                add(selectDate.errorMessage("Bitte wählen Sie ein Datum aus."))
            } else {
                val now = LocalDate.now()
                val oneYearInThePast = now.minus(1, DateTimeUnit.YEAR)
                if (selectDate.data!! !in oneYearInThePast..now)
                    add(selectDate.errorMessage("Das Datum darf nicht in der Zukunft und maximal 1 Jahr in der Vergangenheit liegen."))
            }
        }
    }
}